// WO (Work Order) Endpoints Constants
export const WO_ENDPOINTS = {
  // Vessel WO Operations
  VESSEL_WO_STATUS: (vesselCode: string) => `/vessel/${vesselCode}/wo/status`,
  VESSEL_WO_STATUS_UPDATE: (vesselCode: string, woNumber: string) =>
    `/vessel/${vesselCode}/wo/${woNumber}/status`,
  VESSEL_TAG_PREVENTIVE_WOS: (vesselCode: string, tagCode: string) =>
    `/vessel/${vesselCode}/tag/${tagCode}/wo/preventive`,
} as const;
